import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

/**
 * A link to one order, eSIM or customer, the same on every screen.
 *
 * The path of each is written once here: an address can hold a `+`, and a `+`
 * in a raw path segment decodes as a space, so every id is encoded the same
 * way. The link is the focusable thing, never the row -- a table row announced
 * as a button is a lie to anybody not using a mouse.
 */
const BASE =
  "rounded font-medium underline-offset-4 hover:underline focus-visible:outline-none " +
  "focus-visible:ring-2 focus-visible:ring-ring";
/** Codes and ICCIDs, where character shapes matter more than prose. */
const MONO = cn(BASE, "font-mono text-xs");

export const orderPath = (code: string) => `/orders/${encodeURIComponent(code)}`;
export const esimPath = (iccid: string) => `/esims/${encodeURIComponent(iccid)}`;
export const customerPath = (email: string) => `/customers/${encodeURIComponent(email)}`;

export function OrderLink({ code }: { code: string }) {
  return (
    <Link to={orderPath(code)} className={MONO}>
      {code}
    </Link>
  );
}

export function EsimLink({ iccid }: { iccid: string }) {
  return (
    <Link to={esimPath(iccid)} className={MONO}>
      {iccid}
    </Link>
  );
}

export function CustomerLink({ email }: { email: string }) {
  return (
    <Link to={customerPath(email)} className={BASE}>
      {email}
    </Link>
  );
}
